class AnimationManager {
  constructor() {
    this.canvas = null;
    this._update = null;
    this.engine = null;
    this.ticker = null;
  }

  get update() {
    return this._update;
  }

  set update(callback) {
    this._update = callback;
  }
}

export default new AnimationManager();
